module.exports = __webpack_public_path__ + "img/home_900.3fc1ce8c.webp";